import { ProductBySlugNonNullable } from "@/common/contracts/pdp.contracts";
import ProductUtils from "@/components/ProductDetail/utils/ProductUtils";
import { useProductProBuyerPrice } from "@/features/pro-buyer-price/hooks/useProBuyerPrice";
import { PdpReservationBlock } from "@/features/pro-buyer-reservations/components/PdpReservationBlock";
import { usePdpReservation } from "@/features/pro-buyer-reservations/hooks/usePdpReservation";

type PdpReservationSectionProps = {
  product: ProductBySlugNonNullable;
};

/**
 * WHO-5947. Sits in the page flow right under the buy buttons (outside the
 * mobile sticky bar, so the text wraps at 375 px). Renders nothing with the
 * flag off, for sold pieces and for the owner.
 */
export const PdpReservationSection = ({
  product,
}: PdpReservationSectionProps) => {
  const isOwner = !!product.isOwner;
  const view = usePdpReservation(product.id, isOwner);
  const { price: proBuyerPrice } = useProductProBuyerPrice(product.id);

  // WHO-5947 F27: a request only on listings with a Pro Buyer price; on all
  // others nothing at all. The gateway and the monolith refuse it as well.
  const requestWithoutProBuyerPrice =
    view.mode === "eligible" && !proBuyerPrice;

  if (
    view.mode === "none" ||
    requestWithoutProBuyerPrice ||
    ProductUtils.isSold(product) ||
    product.merchant.vacationModeEnabledAt
  ) {
    return null;
  }

  const buyNow = product.auction?.buy_now_price;
  const regularPrice =
    buyNow && typeof buyNow.amount === "number"
      ? { amount: buyNow.amount, currency: String(buyNow.currency) }
      : null;
  const price = proBuyerPrice
    ? {
        amount: proBuyerPrice.price.amount,
        currency: String(proBuyerPrice.price.currency),
      }
    : regularPrice;

  return (
    // F2: no negative margin; it slid under the white buy-button block (z-50).
    <div className="relative mb-6 mt-3">
      <PdpReservationBlock
        productId={product.id}
        view={view}
        price={price}
        isProBuyerPrice={!!proBuyerPrice}
      />
    </div>
  );
};
